// src/layouts/PublicLayout.js
import React from 'react';
import { Outlet } from 'react-router-dom';

const PublicLayout = () => {
  return (
    <div>
      <Outlet /> {/* Renders the child routes like Login, Signup */}
    </div>
  );
};

export default PublicLayout;
